import { useEffect, useState ,useRef} from "react";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";
import { FaEdit,FaMinusCircle} from "react-icons/fa";

export default function CatalogScreen() {

  const [loading, setLoading] = useState(false);
  const [catalogs, setCatalogs] = useState([
    //     [{
    //     id: 1,
    //     name: "Countries",
    //     isActive: true,
    //     entries: [
    //     { code: "IN", name: "India", isActive: true },
    //     { code: "US", name: "United States", isActive: true },
    //     { code: "UK", name: "United Kingdom", isActive: false }
    //     ]
    // },
    // {
    //     id: 2,
    //     name: "Departments",
    //     isActive: true,
    //     entries: [
    //     { code: "HR", name: "Human Resources", isActive: true },
    //     { code: "ENG", name: "Engineering", isActive: true },
    //     { code: "FIN", name: "Finance", isActive: false }
    //     ]
    // },
    // {
    //     id: 3,
    //     name: "User Roles",
    //     isActive: true,
    //     entries: [
    //     { code: "ADMIN", name: "Administrator", isActive: true },
    //     { code: "DOC", name: "Doctor", isActive: true },
    //     { code: "PAT", name: "Patient", isActive: true }
    //     ]
    // }
    ]);
  //const [showModal, setShowModal] = useState(false);
  //const academicYearId = sessionStorage.getItem('academicYearId')

  const [selectedCatalog, setSelectedCatalog] = useState(null);
   const hasFetched = useRef(false);

  const loadCatalogs = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/catalogs");
      setCatalogs(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
      hasFetched.current = true;
    loadCatalogs();
  }, []);

 // handle field change
  const handleEntryChange = (index, field, value) => {
    setSelectedCatalog(prev => {
      const updatedEntries = [...prev.entries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        [field]: value
      };
      return { ...prev, entries: updatedEntries };
    });
  };

  // add new section
  const addEntry = () => {
    setSelectedCatalog(prev => ({
      ...prev,
      entries: [...prev.entries, { code: "",name:"", isActive: true}]
    }));
  };

  // delete section
  const deleteEntry = (index) => {
    setSelectedCatalog(prev => {
      const updatedEntries = prev.entries.filter((_, i) => i !== index);
      return { ...prev, entries: updatedEntries };
    });
  };

  const handleChange = (e) => {const { name, value } = e.target;
    setSelectedCatalog({
      ...selectedCatalog,
      [name]: value
    });
  };

  const openNew = () => {

    setSelectedCatalog({
      catalogNamename: "",
      isActive: true,
      entries:[{ code: "", name: "", isActive: true }]
    });

  };

  const onClose = () => {
    setSelectedCatalog(null);
  };


  const saveCatalog = async () => {

    try {
      setLoading(true);
      const response = await axiosInstance.post("/catalogs/save", selectedCatalog);
      if (response.data.status === "SUCCESS") {
          alert("Catalog Saved Successfully");
          setSelectedCatalog(null);
          loadCatalogs();
        }else{
             if (response.data.errors && response.data.errors.length > 0) {
              alert(response.data.errors.join("\n")); // show all errors
            } else {
              alert(response.message || "Error in Saving Class");
            }
        }
    } catch (err) {
      console.error(err);
      //alert("Error in Save Class");
    } finally {
      setLoading(false);
    }

  };

  return (

    <div className="p-4 md:p-6">

      {loading && <Loader />}

      {/* Header */}
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-xl font-semibold">
          Catalogs
        </h1>

        <button
          onClick={openNew}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          New
        </button>

      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-lg overflow-x-auto">

        <table className="w-full text-sm">

          <thead className="bg-gray-100">

            <tr>
              <th className="text-left p-3">Catalog Name</th>
              <th className="text-left p-2">Is Active</th>
              <th className="text-left p-1">Edit</th>
              {/* <th className="text-right p-3"> " "</th> */}
            </tr>

          </thead>

          <tbody>
            {catalogs.length > 0 ? (
              catalogs.map((Catalog) => (

              <tr key={Catalog.id} className="border-t">

                <td className="p-3">
                   <div className="flex items-center gap-2">
                  {Catalog.catalogName}
                  <button className="text-gray-500 hover:text-blue-600"  >
                  </button>
                  </div>
                </td>

               <td className="p-2">
                  {Catalog.active ? "Yes" : "No"}
                </td>

                <td className="p-1">

                  <button
                    onClick={() => setSelectedCatalog(Catalog)} className="text-blue-500 hover:underline"
                  >
                    <FaEdit size={14} />
                  </button>

                </td>

              </tr>

            ))
          ): (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No Catalogs found
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* Popup Modal */}
      {selectedCatalog && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-2">

          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">

            {/* Header */}
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-lg text-blue-600 font-semibold">Catalog Details</h2>

              <div className="flex justify-end gap-6">
              <button
                type="button"
                onClick={saveCatalog} 
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Save
              </button>
              <button
                onClick={onClose}
                className="text-red-500 font-bold"
              >
                X
              </button>
              </div>
            </div>

            <div className="p-4 space-y-6">
              {loading && <Loader />}
              {/* Class Info */}
              <div>
                <h3 className="font-bold mb-2">Catalog Information :</h3>

                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3">

                  <div>
                  <label className="font-medium">Name</label>
                  <input
                    type="text" name="catalogName" onChange={handleChange}
                    value={selectedCatalog.catalogName || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                  </div>
                 
                  <div>
                    <label className="font-medium">Active</label>
                    <select
                      value={selectedCatalog.active}
                      name="active" onChange={handleChange}
                      className="w-full border rounded px-2 py-1"
                    >
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                </div>

                </div>
              </div>

              {/* Entries */}
              <div>
                <div className="flex justify-between items-center border-b">
                   <h3 className="font-bold mb-2">Options :</h3>
                  <button
                    onClick={addEntry}
                    className="text-blue-500 font-bold"
                  >
                   + Add
                  </button>
                </div>

                {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-3"> */}

                  {selectedCatalog?.entries?.map((entry,index) => (
                    
                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    {/* Section Name */}
                    <div>
                      <label className="font-medium">Code</label>
                      <input
                        type="text"
                        name="code"
                        value={entry.code || ""}
                        onChange={(e) =>
                          handleEntryChange(index, e.target.name, e.target.value)
                        }
                        className="w-full border rounded px-2 py-1"
                      />
                    </div>
                    <div>
                      <label className="font-medium">Name</label>
                      <input
                        type="text"
                        name="name"
                        value={entry.name || ""}
                        onChange={(e) =>
                          handleEntryChange(index, e.target.name, e.target.value)
                        }
                        className="w-full border rounded px-2 py-1"
                      />
                    </div>

                    {/* Active + Delete in same row */}
                    <div className="grid grid-cols-2 gap-2 items-end">
                      <div>
                        <label className="font-medium">Active</label>
                        <select
                          value={entry.active}
                          name="active"
                          onChange={(e) =>
                            handleEntryChange(index, e.target.name, e.target.value)
                          }
                          className="w-full border rounded px-2 py-1"
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </div>

                      <div className="flex items-end">
                        <button
                          type="button"
                          onClick={() => deleteEntry(index)}
                          className="text-red-500 font-bold px-1"
                        >
                          <FaMinusCircle size={30}/>
                        </button>
                      </div>
                    </div>
                  </div>
                  ))}

                {/* </div> */}
              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  );
}